import { CONSTANTS__client } from '@/constants/CONSTANTS__client';
import { set_timeout } from '@/utils/utils_client';
import { loge } from '@shared/utils/utils_logs';
import { useCallback, useRef } from 'react';
import { use_effect } from '../_base/use_effect';

export function use_debounced_function_async<T extends (...args: any[]) => Promise<any>>(callback: T, delay_ms: number) {
  /*
   * STATE
   */

  const ref_timeout = useRef(CONSTANTS__client.NUMBER_EMPTY_VALUE);
  const ref_last_promise = useRef(Promise.resolve(null));

  /*
   * EFFECTS
   */

  const out = useCallback(
    (...args: Parameters<T>): Promise<ReturnType<T>> => {
      return new Promise<ReturnType<T>>((resolve, reject) => {
        clearTimeout(ref_timeout.current);

        ref_timeout.current = set_timeout(async () => {
          try {
            const result = await callback(...args);
            ref_last_promise.current = Promise.resolve(result);
            resolve(result);
          } catch (error) {
            loge('', { error });
            reject(error);
          }
        }, delay_ms);
      });
    },
    [callback, delay_ms],
  );

  use_effect(() => {
    return () => cancel();
  }, [callback, delay_ms]);

  /*
   * METHODS
   */

  function cancel() {
    clearTimeout(ref_timeout.current);
    ref_timeout.current = NaN;
    ref_last_promise.current = Promise.resolve(null);
  }

  /*
   * RESULT
   */

  return out;
}
